<template>
  <section>
    <nav
      class="
        scrollbar-none
        overflow-x-auto
        flex
        items-center
        space-x-1
        mb-3
        whitespace-nowrap
      "
    >
      <a
        @click.prevent="view='crypto'"
        href="#"
        :class="(view == 'crypto') ? 'bg-blue-800 text-white' : 'bg-gray-100 text-gray-400'"
        class="
          rounded-tl-md
          flex-1
          p-2
          md:p-4
          text-center
          font-light
          hover:bg-blue-800
          hover:text-white
        "
      >
        Crypto
      </a>
      <a
        @click.prevent="view='forex'"
        href="#"
        :class="(view == 'forex') ? 'bg-blue-800 text-white' : 'bg-gray-100 text-gray-400'"
        class="
          flex-1
          p-2
          md:p-4
          text-center
          font-light
          hover:bg-blue-800
          hover:text-white
        "
      >
        Forex
      </a>
      <a
        @click.prevent="view='stock'"
        href="#"
        :class="(view == 'stock') ? 'bg-blue-800 text-white' : 'bg-gray-100 text-gray-400'"
        class="
          flex-1
          p-2
          md:p-4
          text-center
          font-light
          hover:bg-blue-800
          hover:text-white
        "
      >
        Stock
      </a>
    </nav>
    <crypto-table-data v-if="view=='crypto'"></crypto-table-data>
    <forex-table-data v-if="view=='forex'"></forex-table-data>
    <stock-table-data v-if="view=='stock'"></stock-table-data>
    <indices-table-data v-if="view=='indices'"></indices-table-data>
  </section>
</template>
<script>

import CryptoTableData from './CryptoTableData.vue';
import ForexTableData from './ForexTableData.vue';
import StockTableData from './StockTableData.vue';
import IndicesTableData from './IndicesTableData.vue';

const axios = require('axios');
export default {
  components: {CryptoTableData, ForexTableData, IndicesTableData, StockTableData},
  data() {
		return {
      view: 'crypto',
    };
	},
  created() {
    	
  },
}
</script>